import { useContext } from 'react';

import PdfUrlContext from '../pdfUrl/context';
import { PdfUrlValue } from '../pdfUrl/types';

export function usePdfUrl (): PdfUrlValue {
  const context = useContext(PdfUrlContext);
  if (context === undefined) {
    throw new Error('The hook usePdfUrl() must be used within a PdfUrlProvider.');
  }
  return context;
}
